module.exports = __webpack_public_path__ + "img/company_logo.3ec2cb00.png";